import { useState, useEffect } from "react";

export default function PhoneInput(props) {
    const [countryCode] = useState(1); 
    const [serviceProviderNumber, setServiceProviderNumber] = useState(props.value?.serviceProviderNumber || "");
    const [phoneNumber, setPhoneNumber] = useState(props.value?.phoneNumber || "");

    useEffect(() => {
        props.onValueChange(
            countryCode && serviceProviderNumber && phoneNumber !== ""
                ? { countryCode, serviceProviderNumber, phoneNumber }
                : null
        );
    }, [countryCode, serviceProviderNumber, phoneNumber]);

    useEffect(() => {
        if (props.value !== null) {
            if (props.value.serviceProviderNumber === null) setServiceProviderNumber("");
            if (props.value.phoneNumber === "") setPhoneNumber("");
        }
    }, [props.value]);

    return (
        <div className={`form-field w-full ${props.xlassName || ""}`}>
            <label className={`text-sm font-bold md:text-base ${props.color}`}>{props.placeholder}</label>
            <div className="grid min-w-0 grid-cols-[auto_minmax(4.75rem,0.45fr)_minmax(0,1fr)] items-center gap-2">
                <p className={props.variant === 'registration'
                    ? 'flex min-h-[52px] items-center rounded-lg border border-gray-300 bg-gray-50 px-3 text-sm font-semibold text-neutral-700'
                    : 'p-2 font-medium text-white'}>
                    +36
                </p>

                <select
                    disabled={props.disabled}
                    value={serviceProviderNumber}
                    onChange={(e) => setServiceProviderNumber(e.target.value)}
                    className={`input w-full min-w-0 rounded-xl p-2 ${props.error ? "border-red-500" : ""}`}
                >
                    <option value="" disabled>--</option>
                    <option value="1">20</option>
                    <option value="2">30</option>
                    <option value="3">50</option>
                    <option value="4">70</option>
                    <option value="5">31</option>
                </select>

                <input
                    type="text"
                    maxLength={7}
                    disabled={props.disabled}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))} // Ensure only numbers
                    className={`input w-full min-w-0 rounded-xl p-2 ${props.error ? "border-red-500" : ""}`}
                    placeholder={props.placeholder}
                />
            </div>

            {props.error && <p className="text-red-500 text-xs">{props.error}</p>}
        </div>
    );
}
